// Página inicial: uma página com secções (como o site estático original), na língua do endereço ("/" = língua por omissão, hoje EN).
// Cada secção pode ser desligada no backoffice (área "Site"): ver lib/sections.ts.
import type { Lang } from "@ecliptica/i18n";
import { useSiteSections } from "../../lib/sections";
import { BooksSection } from "./BooksSection";
import { CardsStrip } from "./CardsStrip";
import { ComicSection } from "./ComicSection";
import { DownloadsSection } from "./DownloadsSection";
import { Hero } from "./Hero";
import { PlaySection } from "./PlaySection";
import { WorldSection } from "./WorldSection";

export function HomePage({ lang }: { lang: Lang }) {
  const on = useSiteSections();
  return (
    <>
      <Hero lang={lang} sections={on} />
      {on.game && <PlaySection />}
      {on.cards && <CardsStrip lang={lang} />}
      {on.world && <WorldSection lang={lang} />}
      {on.books && <BooksSection lang={lang} />}
      {on.comic && <ComicSection lang={lang} />}
      {on.downloads && <DownloadsSection lang={lang} sections={on} />}
    </>
  );
}
